import { Scene } from 'phaser';

export class Preloader extends Scene
{
    constructor ()
    {
        super('Preloader');
    }

    init ()
    {
        //  We loaded this image in our Boot Scene, so we can display it here
        this.add.image(512, 384, 'background');

        //  A simple progress bar. This is the outline of the bar.
        this.add.rectangle(512, 384, 468, 32).setStrokeStyle(1, 0x61b85d);

        //  This is the progress bar itself. It will increase in size from the left based on the % of progress.
        const bar = this.add.rectangle(512-230, 384, 4, 28, 0x5a9458);

        //  Use the 'progress' event emitted by the LoaderPlugin to update the loading bar
        this.load.on('progress', (progress: number) => {

            //  Update the progress bar (our bar is 464px wide, so 100% = 464px)
            bar.width = 4 + (460 * progress);

        });
    }

    preload ()
    {
        //  Load the assets for the game
        this.load.setPath('assets');

        for (let i = 1; i <= 4; i++) {
            this.load.spritesheet("player" + i, "players/player" + i + ".png", {frameWidth: 200, frameHeight: 282});
        }        

        for (let i = 1; i <= 4; i++) {
            this.load.spritesheet("bee" + i, "bees/bee" + i + ".png", {frameWidth: 50, frameHeight: 71});
        }

        this.load.spritesheet("gamepad_handle", "gamepad_handle.png", {frameWidth: 459, frameHeight: 192 });
        this.load.spritesheet("gamepad_a_button", "gamepad_a_button.png", {frameWidth: 459, frameHeight: 192 });
        
        this.load.image("flowerpot", "flowerpot.png");
        this.load.image("wateringcan", "wateringcan.png");
        this.load.image("vase", "vase.png");
        this.load.image("bud", "bud.png");
        this.load.image("plant", "plant.png");
        this.load.image("sun", "sun.png");
        this.load.image("bg_overlay", "bg_overlay.png");
        this.load.image("bg2", "bg2.png");
        this.load.image("water", "particles/white-flare.png");
        this.load.image("nl", "flags/nl.png");
        this.load.image("en", "flags/en.png");

        for (let i = 1; i <= 8; i++) {
            this.load.image("flower" + i, "flowers/flower" + i + ".png");
        }

        this.load.audio("splash1", "sound/effects/water splashing small 14.wav");
        this.load.audio("splash2", "sound/effects/water splashing small 16.wav");
        this.load.audio("splash3", "sound/effects/water splashing small 12.wav");
        this.load.audio("scissors1", "sound/effects/scissors 1.wav");
        this.load.audio("leaves1", "sound/effects/leaves rustle 5.wav");
        this.load.audio("glad1", "sound/effects/glad1.wav");
        this.load.audio("glad2", "sound/effects/glad2.wav");
        this.load.audio("glad3", "sound/effects/glad3.wav");
        
        this.load.audio("pop1", "sound/music/pop1.mp3");
    }

    create ()
    {
        //const music = this.sound.add("pop1", { loop: true });
        //music.play("pop1");
        this.sound.play("pop1", { loop: true, volume: 0.7 });
        //  When all the assets have loaded, it's often worth creating global objects here that the rest of the game can use.
        //  For example, you can define global animations here, so we can use them in other scenes.

        //  Move to the MainMenu. You could also swap this for a Scene Transition, such as a camera fade.
        this.scene.start('MainMenu');
    }
}
